<div class="home-feed-section__wrapper"
     [class.content-wrapper-has-content]="hasContent">
  <div class="home-feed-section__header">
    <typography-legacy
      text-large-semibold
      class="home-feed-section__header-title"
      color="var(--primary-text)">
      {{ sectionTitle }}
    </typography-legacy>
    <typography-legacy
    text-medium-regular
    color="var(--brand)">
      <a *ngIf="routerLocation"
         [routerLink]="routerLocation">{{'SHOW_ALL'|translate}}</a>
    </typography-legacy>
  </div>
  <div class="home-feed-section__content">
    <div #contentWrapper>
      <ng-content></ng-content>
    </div>
    <bw-spinner-legacy *ngIf="showLoading"></bw-spinner-legacy>
  </div>
</div>


